import React from "react";
// import UpcominVisits from "../UpcomingVisits";
// import SimilarInsights from "../SimilarInsights";
// import placeholder from "../../../Assets/Images/physician-2.png";
import placeholder1 from "../../../Assets/Images/physician-3.png";

const RightSectionCommon = () => {
  return (
    // style only for placeholder, remove when restoring features
    <div className="right-section-top" style={{ justifyContent: "flex-start" }}>
      {/* Disabled for phase 1 */}
      {/* <UpcominVisits /> */}
      {/* <SimilarInsights /> */}
      {/* Placeholder for phase 1 */}
      {/* <div className="container3">
        <p className="body1 medium-grey">Feature in development</p>
      </div> */}

      <div className="container3">
        <p>Recommended Links</p>
        <ul style={{ padding: "0 10px", margin: 0 }}>
          <li className="body1 medium-grey" style={{ paddingBottom: "5px" }}>
            <a
              href="https://www.nccn.org/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              NCCN{" "}
            </a>
          </li>
          <li className="body1 medium-grey" style={{ paddingBottom: "5px" }}>
            <a
              href="https://www.esmo.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ESMO{" "}
            </a>
          </li>
          <li className="body1 medium-grey" style={{ paddingBottom: "5px" }}>
            <a
              href="https://www.asco.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ASCO{" "}
            </a>
          </li>
        </ul>
      </div>
      <div
        style={{
          background: `url(${placeholder1}) 50% / cover no-repeat`,
          height: "80%",
        }}
      ></div>
      {/* <div className="container3">
        <p>Your links</p>
        <ul>
          <li className="body1 medium-grey">
            <a href="https://www.nccn.org/home"> NCCN </a>
          </li>
          <li className="body1 medium-grey">
            <a href="https://www.esmo.org/">ESMO </a>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default RightSectionCommon;
